import "./ConfirmDialog.css";

export default function ConfirmDialog({

    open,

    title = "Confirm",

    message,

    confirmText = "Confirm",

    cancelText = "Cancel",

    loading = false,

    onConfirm,

    onCancel

}){

    if(!open){

        return null;

    }

    return(

        <div className="confirm-overlay">

            <div className="confirm-dialog">

                <div className="confirm-header">

                    <div className="confirm-icon">

                        ⚠

                    </div>

                    <h2>

                        {title}

                    </h2>

                </div>

                <div className="confirm-body">

                    {message}

                </div>

                <div className="confirm-footer">

                    <button

                        className="btn"

                        onClick={onCancel}

                        disabled={loading}

                    >

                        {cancelText}

                    </button>

                    <button

                        className="btn btn-danger"

                        onClick={onConfirm}

                        disabled={loading}

                    >

                        {

                            loading

                            ? "Please wait..."

                            : confirmText

                        }

                    </button>

                </div>

            </div>

        </div>

    );

}